export const searchTips = {
    order_number: {
        label: 'an order number',
        applications: ['aap', 'wayste', 'customer-portal'],
        entities: [
            'sourgum-order',
            'sourgum-payable',
            'sourgum-receivable',
            'sourgum-service-grouping',
            'wayste-order',
            'wayste-payable',
            'wayste-receivable',
        ],
    },
    name: {
        label: 'customer name',
        applications: ['aap', 'wayste'],
        entities: [
            'sourgum-customer',
            'wayste-customer',
            'sourgum-lead',
            'sourgum-order',
            'sourgum-receivable',
            'sourgum-service-grouping',
            'wayste-commercial-subscription',
            'wayste-order',
            'wayste-receivable',
        ],
    },
    address: {
        label: 'customer address',
        applications: ['aap', 'wayste', 'customer-portal'],
        entities: [
            'sourgum-customer',
            'wayste-customer',
            'sourgum-lead',
            'sourgum-order',
            'sourgum-receivable',
            'sourgum-service-grouping',
            'wayste-commercial-subscription',
            'wayste-order',
        ],
    },
    dumpster: {
        label: 'dumpster name/number',
        applications: ['wayste'],
        entities: ['wayste-dumpster', 'wayste-tagged-container'],
    },
    email: {
        label: 'customer email',
        applications: ['aap', 'wayste'],
        entities: ['sourgum-customer', 'wayste-customer', 'sourgum-lead'],
    },
    phone: {
        label: 'customer phone number',
        applications: ['aap', 'wayste'],
        entities: ['sourgum-customer', 'wayste-customer', 'sourgum-lead'],
    },
    vendor: {
        label: 'partner hauler name',
        applications: ['aap'],
        entities: ['sourgum-order', 'sourgum-payable', 'sourgum-service-grouping'],
    },
    account_number: {
        label: 'customer account number',
        applications: ['aap', 'wayste'],
        entities: [
            'sourgum-customer',
            'wayste-customer',
            'sourgum-order',
            'sourgum-receivable',
            'sourgum-service-grouping',
            'wayste-commercial-subscription',
            'wayste-order',
        ],
    },
};
export const filterSearchTips = (application, entity) => {
    return Object.entries(searchTips)
        .filter((item) => item[1].applications.includes(application) && item[1].entities.includes(entity))
        .map(([key, value]) => ({ key, hint: value.label }));
};
//# sourceMappingURL=search-tip-schema.js.map